// extracted by mini-css-extract-plugin
export default {"search":"UserList_search__sKH0W","container":"UserList_container__GsgZ2","pagination":"UserList_pagination__PH9kM"};